var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchNotAcceptedSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64922 0.656006C3.09043 0.656006 0.207031 3.5394 0.207031 7.09819C0.207031 10.657 3.09043 13.5404 6.64922 13.5404C10.208 13.5404 13.0914 10.657 13.0914 7.09819C13.0914 3.5394 10.208 0.656006 6.64922 0.656006ZM3.22031 8.13726C3.04887 8.13726 2.90859 7.99698 2.90859 7.82554V6.37085C2.90859 6.1994 3.04887 6.05913 3.22031 6.05913H10.0781C10.2496 6.05913 10.3898 6.1994 10.3898 6.37085V7.82554C10.3898 7.99698 10.2496 8.13726 10.0781 8.13726H3.22031Z",
    fill: "#DF2929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNotAcceptedSm);
export default __webpack_public_path__ + "static/media/search_not_accepted_sm.f621d32e255d9c2aeed57622b665aa02.svg";
export { ForwardRef as ReactComponent };